/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2019, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'jquery',
	'./CustomUtil'
], function(
	$,
	CustomUtil
) {

	const INPUT_FILE_BROWSE_DIALOG = '<input type="file" id="custom-vis-uploadfiles" style="display: none;" accept="application/zip,application/x-zip-compressed,multipart/x-zip,application/x-compressed" onclick="this.value=null;">';

	return class CustomVisAction {
		constructor(options) {
			this.dashboardApi = options.dashboardApi;
			this.refreshCustomVis = options.refreshCustomVis;
			this.enabled = this.dashboardApi.getConfiguration('enableCustomVisualizations') === true;
			this._loadUserCapabilities();
		}

		openSelectBundleFileDialog(item) {
			this.item = item;
			this.$uploadFileButton.click();
		}

		bundleFileSelected(event, refreshCustomVisDefinitionsCallback) {
			const viprBundleMethod = this.item ? CustomUtil.updateCustomVis : CustomUtil.addCustomVis;
			return viprBundleMethod(event, this.dashboardApi, refreshCustomVisDefinitionsCallback, this.item).then((items) => {
				if (items) {
					this.setItems(items);
				}
			});
		}

		setItems(items = []) {
			//First clear the items
			this.customVisualsContentComponent.setState({
				items: []
			});
			//Now re-render with new list
			this.customVisualsContentComponent.setState({
				items: items
			});
		}

		shouldRefreshCustomPanel () {
			return this.canDevelop() || this.canManage();
		}

		createUploadFileNode (refreshCustomVisDefinitionsCallback) {
			//Ensure the existing got removed before creating new one
			this.removeUploadFileNode();

			this.$uploadFileButton = $(INPUT_FILE_BROWSE_DIALOG);

			$('body').append(this.$uploadFileButton);

			this.$uploadFileButton.on('change', (event) => {
				this.bundleFileSelected(event, refreshCustomVisDefinitionsCallback);
			});
			this.$uploadFileButton.on('onClick', () => { this.$uploadFileButton.value = null; });
		}

		removeUploadFileNode () {
			if (this.$uploadFileButton && this.$uploadFileButton.length > 0) {
				this.$uploadFileButton.remove();
				this.$uploadFileButton = null;
			}
		}

		setCustomVisualsContentComponent (component) {
			this.customVisualsContentComponent = component;
		}

		destroy () {
			this.removeUploadFileNode();
			this.customVisualsContentComponent = null;
			this.dashboardApi = null;
			this.refreshCustomVis = null;
		}

		canDevelop() {
			return this.capabilities.canDevelop;
		}

		canManage() {
			return this.capabilities.canManage;
		}

		canManageOnly() {
			return this.capabilities.canManageOnly;
		}

		canUseOnly() {
			return this.capabilities.canUseOnly;
		}

		isEnabled() {
			return this.enabled;
		}

		_loadUserCapabilities () {
			// __glassAppController.glassContext.getCoreSvc('.FeatureChecker').addRules({'dashboard':{'canDevelopVisualizations': 'enabled'}})
			//__glassAppController.glassContext.getCoreSvc('.FeatureChecker').addRules({'dashboard':{'canManageVisualizations': 'enabled'}})
			const userCapabilities = this.dashboardApi.getGlassCoreSvc('.UserProfile').capabilities;
			const canDevelop = userCapabilities.indexOf('canDevelopVisualizations') !== -1 || this.dashboardApi.getGlassCoreSvc('.FeatureChecker').checkValue('dashboard', 'canDevelopVisualizations', 'enabled');
			const canManage = userCapabilities.indexOf('canManageVisualizations') !== -1 || this.dashboardApi.getGlassCoreSvc('.FeatureChecker').checkValue('dashboard', 'canManageVisualizations', 'enabled');

			this.capabilities = {
				canDevelop: canDevelop,
				canManage: canManage,
				canManageOnly: !canDevelop && canManage,
				canUseOnly: !canDevelop && !canManage
			};
		}
	};
});
